export default __webpack_public_path__ + "static/media/finger3.3e8fd8eb.png";